import { io } from 'socket.io-client';
import { generateMediaRoomId } from './utils';
import { messageService } from './message';

const MEDIA_SERVER_URI =
	process.env.REACT_APP_MEDIA_SERVER_URL || "https://ai.dedahospital.com";

let socket = null;
let appToken = null;

export const connectMediaSocket = (doctorId, token) => {
	if (!doctorId || !token) return;

	// Reuse existing connected socket to avoid unnecessary reconnections
	if (socket && socket.connected) {
		return socket;
	}

	// Clean up any stale socket before creating a new one
	if (socket) {
		socket.off('connect');
		socket.off('disconnect');
		socket.disconnect();
		socket = null;
	}

	socket = io(MEDIA_SERVER_URI, {
		transports: ['websocket', 'polling'], // polling fallback for hostile networks
		path: '/media/socket.io',
		autoConnect: true,
		query: {
			userId: `${doctorId}`,
			token: token || localStorage.getItem('token'),
			type: 'patient',
		},
	});

	appToken = token;

	socket.on('connect', () => {
		console.log('Doctor socket connected:', socket?.id, doctorId, token);
	});

	socket.on('disconnect', (reason) => {
		console.log('Doctor socket disconnected, reason:', reason);
	});
};

export const disconnectMediaSocket = () => {
	if (socket) {
		socket.off('connect');
		socket.off('disconnect');
		socket.disconnect();
		socket = null;
	}
};

// export const subscribeMediaIO = () => {
// 	// console.log(socket,'getting private messages from socket.io');
// 	socket.on('private-message', data => {
// 		console.log(`'private-message' to socket.io`, data);
// 		messageService.sendMessage({ type: 'private-media-message', data });
// 	});

// 	console.log('[subscribeMediaIO] Socket ready?', !!socket);
// };

export const Register = ({ userId }) => {
	if (!socket) {
		return;
	}
	socket.emit('register', { userId }, res => {
		if (res) {
			console.log('[Register] Socket registered successfully:', res);
		} else {
			console.log('[Register] Socket registration failed:', res);
		}
	});
};



export const subscribeMediaIO = (onCallRequest, onCallCancelled) => {
	if (!socket) {
		console.log('[subscribeMediaIO] Socket not initialized');
		return;
	}

	// Existing private-message handler
	socket.on('private-message', data => {
		console.log(`'private-message' to socket.io`, data);
		messageService.sendMessage({ type: 'private-media-message', data });
	});


	// Handle incoming call request
	socket.on('call-request', data => {
		console.log('📞 Incoming call request:', data);
		if (onCallRequest) {
			onCallRequest(data);
		}
	});

	// Handle call cancelled (initiator cancelled or answered on another device)
	socket.on('call-cancelled', data => {
		console.log('Call cancelled:', data);
		if (onCallCancelled) {
			onCallCancelled(data);
		}
	});

	// Handle call accepted
	socket.on('accept-call', data => {
		console.log('Call accepted:', data);
	});

	// Handle call rejected
	socket.on('call-rejected', data => {
		console.log(' Call rejected:', data);
	});

	// Handle call initiated
	socket.on('call-initiated', data => {
		console.log('📞 Call initiated:', data);
	});

	// Handle peer disconnection
	socket.on('peer-disconnected', data => {
		console.log('Peer disconnected:', data);
	});

	console.log('[subscribeMediaIO] Socket ready?', !!socket);
};

export const getRecentMediaChats = ({ doctorId, token }, cb) => {
	if (!socket) {
		return;
	}
	socket.emit('get-recent-patient-chats', { userId: doctorId, token: token }, res => {
		if (cb) {
			const chats = Array.isArray(res) ? res : [];
			cb(chats);
		}


	});
};

export const getChatHistoryByPatient = ({ doctorId, patientId }, cb) => {
	console.log('Socket not initialized')
	if (!socket) {
		return (
			console.log('Socket not initialized')
		);
	}
	socket.emit(
		'join-room',
		{
			roomId: generateMediaRoomId({ patientId, doctorId }),
			userId: patientId,
			userType: 'patient',
			roomType: 'chat',
			token: localStorage.getItem('token'),
		},
		res => {
			if (!res || !res.rtpCapabilities) {
				console.log('Call back failed, Joining room');
			}
		}
	);
	socket.emit('get-chat-history', { currentUserId: `${patientId}`, withUserId: `${doctorId}` }, res => {
		console.log('chats from socket');
		if (cb) {
			const chats = Array.isArray(res) ? res : [];
			cb(chats);
		}
	});
};

export const sendMediaMessage = data => {
	if (!socket) {
		return;
	}
	socket.emit('private-message', data);
};

export const joinMediaChatRoom = ({ roomId, doctorId, roomType }) => {
	if (!socket) {
		return;
	}
	socket.emit('join-room', { roomId: `${roomId}`, userId: `${doctorId}`, userType: 'patient', roomType, token: appToken }, res => {
		if (!res || !res.rtpCapabilities) {
			console.log('Call back failed, Joining room');
		}
	});
};

export const leaveMediaChatRoom = ({ roomId, doctorId, roomType = 'chat' }) => {
	if (!socket) {
		return;
	}
	socket.emit('leave-room', { roomId: `${roomId}`, userId: `${doctorId}`, roomType }, res => {
		if (res && res.success) {
			console.log('Left media chat room successfully');
		} else {
			console.log('Failed to leave media chat room');
		}
	});
};

export const markMessageAsRead = ({ fromUserId, toUserId }) => {
	if (!socket) {
		return;
	}
	socket.emit('mark-as-read', { fromUserId, toUserId });
};

export const getMediaSocket = () => socket;
export const getAppToken = () => appToken;
